// 无人机模式
export default {
    'UM1': 'Режим взлета не летает',
    'UM2': 'Не удалось выполнить взлет',
    'UM3': 'Взлет приостановлен',
    'UM4': 'Идёт взлетать',
    'UM5': 'Взлет завершен',
    'UM6': 'Режим посадки не летает',
    'UM7': 'Не удалось выполнить посадку. ',
    'UM8': 'Приостановить посадки',
    'UM9': 'Идёт посадки',
    'UM10': 'Идёт аварийную посадки',
    'UM11': 'Посадка завершена',
    'UM12': 'Не удалось выполнить обратный маршрут',
    'UM13': 'Приостановить обратный маршрут',
    'UM14': 'Обратный маршрут идёт посадки',
    'UM15': 'Идёт обратный маршрут',
    'UM16': 'Обратный маршрут идёт в точку взлета',
    'UM17': 'Возврат завершен',
    'UM18': 'Не удалось выполнить первоначальный обратный маршрут',
    'UM19': 'Приостановить обратный маршрут ',
    'UM20': 'Обратный маршрут идёт посадки',
    'UM21': 'Идёт обратный маршрут',
    'UM22': 'Обратный маршрут в точку взлета',
    'UM23': 'Обратный маршрут завершено',
    'UM24': 'Не удалось выполнить обратный маршрут',
    'UM25': 'Приостановить обратный маршрут',
    'UM26': 'Обратный маршрут идёт посадки',
    'UM27': 'Идёт посадки',
    'UM28': 'Летить к точке возврата',
    'UM29': 'Возврат завершен',
    'UM30': 'Наведения без полета',
    'UM31': 'Не удалось выполнить полет наведения',
    'UM32': 'Приостановить полет наведения',
    'UM33': 'Наведения полет взлет',
    'UM34': 'Наведение полета на посадку',
    'UM35': 'Наведение в полете',
    'UM36': 'Процесс режим зависания',
    'UM37': 'Летить в назначенную точку',
    'UM38': 'Выполнение предустановленных действий',
    'UM39': 'Полет наведения завершен. ',
    'UM40': 'вокруг не летать',
    'UM41': 'Летать вогруг не успешно',
    'UM42': 'Приостановить летать вогруг',
    'UM43': 'ограничиваться облётом идёт летать',
    'UM44': 'ограничиваться облётом идёт посадки',
    'UM45': 'идёт ограничиваться облётом',
    'UM46': 'процесс зависания',
    'UM47': 'летать до точку вокруга',
    'UM48': 'Выполнение предустановленных действий',
    'UM49': 'ограничиваться облётом завершает',
    'UM50': 'Увеличенный и стабильный режим не летает',
    'UM51': 'разблокировать величенный и стабильный режим не удалось',
    'UM52': 'Увеличенный и стабильный режим по контроля дистанционного управление',
    'UM53': 'Режим фиксированной высоты не летает',
    'UM54': 'разблокировать режим фиксированной высоты не удалось',
    'UM55': 'Режим фиксированной высоты по контроля дистанционного управление',
    'UM56': 'Режим фиксированной точки не летает',
    'UM57': 'Режим фиксированной точкине удалось',
    'UM58': 'Режим фиксированной точкипо контроля дистанционного управление',
    'UM59': 'Режим фиксированной точкизависания',
    'UM60': 'Автоматические маршруты не летает',
    'UM61': 'Выполнять автоматические маршруты не удалось',
    'UM62': 'Приостановить автоматические маршруты',
    'UM63': 'Автоматические маршруты взлетает',
    'UM64': 'Автоматические маршруты идёт в посадки',
    'UM65': 'Идёт автоматические маршруты',
    'UM66': 'Процесс наведения',
    'UM67': 'Летить к точке маршрута',
    'UM68': 'Выполнение предустановленных действий',
    'UM69': 'Автоматические маршруты завершает',
    'default': 'умолчание'
}